/**
 * Dernière recherche envoyée depuis une barre de recherche (marketplace ou autre page), avec la marque et le
 * modèle qu'elle a posés quand on les connaît. Sur la marketplace, ces filtres restent liés au texte : effacer
 * le texte les retire (search-query-filters.ts). Oubliée dès que le lien est rompu, pour qu'un filtre choisi
 * ensuite à la main ne soit jamais pris pour un filtre de la recherche. Un lien direct reçu d'ailleurs n'a pas ce lien.
 */
const STORAGE_KEY = "joinsteer:search-filters-origin";

export type SearchFiltersOrigin = { query: string; make: string | null; model: string | null };

export function rememberSearchFiltersOrigin(query: string, make: string | null = null, model: string | null = null): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ query: query.trim(), make, model }));
    } catch {
        // Stockage refusé (navigation privée) : les filtres restent posés, sans lien avec le texte
    }
}

export function readSearchFiltersOrigin(): SearchFiltersOrigin | null {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as Partial<SearchFiltersOrigin>;
        return typeof parsed.query === "string"
            ? { query: parsed.query, make: parsed.make ?? null, model: parsed.model ?? null }
            : null;
    } catch {
        return null;
    }
}

export function forgetSearchFiltersOrigin(): void {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // Rien à oublier
    }
}
